import { Outlet } from "react-router-dom";
import SidebarPageWrapper from '../../components/layout/SidebarPageWrapper';
import Sidebar from '../../components/layout/Sidebar';
import SidebarPage from '../../components/layout/SidebarPage';
import TopBar from "../../components/dashboardParts/TopBar";

export default function DashboardPageRoot(props: {}): JSX.Element {
  return (
    <SidebarPageWrapper>
      <Sidebar>
      </Sidebar>
      <SidebarPage>
        <TopBar></TopBar>
        <Outlet />
      </SidebarPage>
    </SidebarPageWrapper>
  );
}